/**
 * Índice del paso corte confirmado en el timeline de cuatro etapas.
 */
export const INDICE_CORTE_CONFIRMADO = 0;

/**
 * Índice del paso asignación de brigada.
 */
export const INDICE_BRIGADA_ASIGNADA = 1;

/**
 * Índice del paso brigada en terreno.
 */
export const INDICE_BRIGADA_TERRENO = 2;

/**
 * Índice del paso reposición en el timeline de cuatro etapas.
 */
export const INDICE_REPOSICION = 3;

/**
 * Índice del paso inicio en el timeline de corte programado o futuro.
 */
export const INDICE_INICIO_PROGRAMADO = 1;

/**
 * Índice del paso reposición en el timeline de tres etapas.
 */
export const INDICE_REPOSICION_PROGRAMADO = 2;

/**
 * Cantidad de etapas cuando hay brigada.
 */
export const CANTIDAD_ETAPAS_CON_BRIGADA = 4;

/**
 * Cantidad de etapas cuando no hay brigada.
 */
export const CANTIDAD_ETAPAS_SIN_BRIGADA = 2;

/**
 * Cantidad de etapas del corte programado en curso.
 */
export const CANTIDAD_ETAPAS_PROGRAMADO = 3;

/**
 * Porcentaje de la barra cuando el corte está normalizado.
 */
export const PROGRESO_COMPLETO = 100;

/**
 * Porcentaje de la barra del corte programado en curso.
 */
export const PROGRESO_MITAD = 50;

/**
 * Espera en milisegundos para volver a medir el timeline tras pintar fuentes e imágenes.
 */
export const ESPERA_REMEDIR_TIMELINE_MS = 50;

/**
 * Marcador que se reemplaza después de traducir para no escapar la fecha en i18n.
 */
export const MARCADOR_CUANDO = '__CUANDO__';

/**
 * Destino de la ventana al abrir Estoy sin luz.
 */
export const DESTINO_VENTANA_NUEVA = '_blank';

/**
 * Relación de la ventana nueva para no dejar acceso al opener.
 */
export const REL_VENTANA_SEGURA = 'noopener,noreferrer';

/**
 * Tecla que cierra paneles y modales.
 */
export const TECLA_ESCAPE = 'Escape';

/**
 * Radio interno del gráfico de clientes.
 */
export const RADIO_INTERNO_GRAFICO = 70;

/**
 * Radio externo del gráfico de clientes.
 */
export const RADIO_EXTERNO_GRAFICO = 80;

/**
 * Separación entre sectores del gráfico de clientes.
 */
export const ANGULO_SEPARACION_GRAFICO = 4;

/**
 * Ángulo de inicio del gráfico de clientes.
 */
export const ANGULO_INICIO_GRAFICO = -270;

/**
 * Radio de las esquinas del gráfico de clientes.
 */
export const RADIO_ESQUINA_GRAFICO = 10;

/**
 * Ancho del trazo del gráfico de clientes.
 */
export const ANCHO_TRAZO_GRAFICO = 0;

/**
 * Ancho y alto del lienzo del gráfico de clientes.
 */
export const TAMANO_GRAFICO = 200;

/**
 * Centro del gráfico de clientes.
 */
export const CENTRO_GRAFICO = '50%';

/**
 * Nombre del sector sin servicio en el gráfico.
 */
export const NOMBRE_SECTOR_SIN_SERVICIO = 'sin';

/**
 * Nombre del sector recuperado en el gráfico.
 */
export const NOMBRE_SECTOR_RECUPERADO = 'rec';

/**
 * Prefijo del identificador del degradado del gráfico.
 */
export const PREFIJO_GRADIENTE_GRAFICO = 'outageGrad';

/**
 * Inicio del degradado del gráfico.
 */
export const OFFSET_INICIO_DEGRADADO = '0%';

/**
 * Fin del degradado del gráfico.
 */
export const OFFSET_FIN_DEGRADADO = '100%';

/**
 * Color inicial del sector sin servicio.
 */
export const COLOR_SIN_SERVICIO_INICIO = '#FE0130';

/**
 * Color final del sector sin servicio.
 */
export const COLOR_SIN_SERVICIO_FIN = '#98011D';

/**
 * Color inicial del sector recuperado.
 */
export const COLOR_RECUPERADO_INICIO = '#4EF3B4';

/**
 * Color final del sector recuperado.
 */
export const COLOR_RECUPERADO_FIN = '#0ECC83';

/**
 * Nodo del timeline ya completado.
 */
export const ESTADO_NODO_HECHO = 'done';

/**
 * Nodo del timeline que está activo.
 */
export const ESTADO_NODO_ACTIVO = 'active';

/**
 * Nodo del timeline que aún no se alcanza.
 */
export const ESTADO_NODO_PENDIENTE = 'pending';

/**
 * Estado visual de un nodo del timeline.
 */
export type StepKind = typeof ESTADO_NODO_HECHO | typeof ESTADO_NODO_ACTIVO | typeof ESTADO_NODO_PENDIENTE;

/**
 * Avance en cero: la barra de progreso no se pinta.
 */
export const PROGRESO_VACIO = 0;

/**
 * Ancho del nodo del timeline que se descuenta al calcular la barra.
 */
export const ANCHO_NODO_TIMELINE_PX = 40;

/**
 * Mínimo de nodos para dibujar un tramo entre centros.
 */
export const CANTIDAD_MINIMA_NODOS_LINEA = 2;

/**
 * Alto mínimo de un tramo cuando dos centros coinciden.
 */
export const ALTO_MINIMO_LINEA = 0;

/**
 * Clave del valor numérico que consume el gráfico de clientes.
 */
export const CLAVE_DATO_GRAFICO = 'value';

/**
 * Lado del ícono de campana en los llamados a notificar.
 */
export const TAMANO_ICONO_CAMPANA = 20;

/**
 * Lado del chevron de ver detalle.
 */
export const TAMANO_ICONO_CHEVRON = 18;

/**
 * Ancho del chevron de volver en el detalle.
 */
export const ANCHO_ICONO_VOLVER = 7;

/**
 * Alto del chevron de volver en el detalle.
 */
export const ALTO_ICONO_VOLVER = 13;

/**
 * Lado del ícono SVG de campana del modal de suscripción.
 */
export const TAMANO_ICONO_CAMPANA_MODAL = 24;

/**
 * Variable CSS del ancho de la barra de progreso.
 */
export const VARIABLE_ANCHO_PROGRESO = '--ancho-progreso';

/**
 * Variable CSS de la posición superior de un tramo de la línea de avance.
 */
export const VARIABLE_LINEA_TOP = '--linea-top';

/**
 * Variable CSS del alto de un tramo de la línea de avance.
 */
export const VARIABLE_LINEA_ALTO = '--linea-alto';

/**
 * Variable CSS del color de un tramo de la línea de avance.
 */
export const VARIABLE_LINEA_COLOR = '--linea-color';

/**
 * Unidad de medida en píxeles para variables CSS.
 */
export const UNIDAD_PX = 'px';

/**
 * Identificador de prueba del timeline de cuatro etapas.
 */
export const TEST_ID_TIMELINE_CUATRO = 'timeline-4';

/**
 * Identificador de prueba del timeline de dos etapas.
 */
export const TEST_ID_TIMELINE_DOS = 'timeline-2';

/**
 * Identificador de prueba del timeline de corte futuro.
 */
export const TEST_ID_TIMELINE_FUTURO = 'timeline-futuro-3';

/**
 * Identificador de prueba del timeline de corte programado.
 */
export const TEST_ID_TIMELINE_PROGRAMADO = 'timeline-programado-3';

/**
 * Identificador de prueba del detalle de cuatro etapas.
 */
export const TEST_ID_DETALLE_CUATRO = 'detalle-timeline-4';

/**
 * Identificador de prueba del detalle de dos etapas.
 */
export const TEST_ID_DETALLE_DOS = 'detalle-timeline-2';

/**
 * Identificador de prueba del detalle de corte futuro.
 */
export const TEST_ID_DETALLE_FUTURO = 'detalle-timeline-futuro-3';

/**
 * Identificador de prueba del detalle de corte programado.
 */
export const TEST_ID_DETALLE_PROGRAMADO = 'detalle-timeline-programado-3';

/**
 * Identificador del paso de corte confirmado.
 */
export const ID_PASO_CORTE = 'corte';

/**
 * Identificador del paso de asignación de brigada.
 */
export const ID_PASO_ASIGNACION = 'asignacion';

/**
 * Identificador del paso de brigada en terreno.
 */
export const ID_PASO_TERRENO = 'terreno';

/**
 * Identificador del paso de reposición.
 */
export const ID_PASO_REPOSICION = 'reposicion';

/**
 * Identificador del paso de notificación.
 */
export const ID_PASO_NOTIFICACION = 'notificacion';

/**
 * Identificador del paso de inicio del corte.
 */
export const ID_PASO_INICIO = 'inicio';

/**
 * Identificador de prueba del dashboard de corte imprevisto.
 */
export const TEST_ID_DASHBOARD = 'outage-dashboard';

/**
 * Identificador de prueba del motivo del corte imprevisto.
 */
export const TEST_ID_MOTIVO = 'outage-motivo';

/**
 * Identificador de prueba del avance del corte imprevisto.
 */
export const TEST_ID_AVANCE = 'outage-avance';

/**
 * Identificador de prueba del enlace al detalle de avance.
 */
export const TEST_ID_TOGGLE_DETALLE = 'toggle-detalle-avance';

/**
 * Identificador de prueba del bloque de reportar corte.
 */
export const TEST_ID_REPORTAR = 'outage-reportar';

/**
 * Identificador de prueba del botón de reportar del dashboard.
 */
export const TEST_ID_BOTON_REPORTAR_DASHBOARD = 'boton-reportar-corte-dashboard';

/**
 * Identificador de prueba del gráfico de clientes.
 */
export const TEST_ID_CHART = 'outage-chart';

/**
 * Identificador de prueba del pie del dashboard.
 */
export const TEST_ID_FOOTER = 'outage-footer';

/**
 * Identificador de prueba del aviso de suscripción TER.
 */
export const TEST_ID_TER_SUSCRITO = 'outage-ter-suscrito';

/**
 * Identificador de prueba del TER sin fecha.
 */
export const TEST_ID_TER_VACIO = 'outage-ter-box-empty';

/**
 * Identificador de prueba del botón de notificar cambio.
 */
export const TEST_ID_BOTON_NOTIFICAR = 'boton-notificar-cambio';

/**
 * Identificador de prueba de la caja de TER.
 */
export const TEST_ID_TER_BOX = 'outage-ter-box';

/**
 * Identificador de prueba de la suscripción inline al TER.
 */
export const TEST_ID_TER_SUSCRITO_INLINE = 'outage-ter-suscrito-inline';

/**
 * Identificador de prueba del dashboard programado.
 */
export const TEST_ID_DASHBOARD_PROGRAMADO = 'outage-dashboard-programado';

/**
 * Identificador de prueba del motivo del corte programado.
 */
export const TEST_ID_MOTIVO_PROGRAMADO = 'outage-motivo-programado';

/**
 * Identificador de prueba de los horarios del corte programado.
 */
export const TEST_ID_HORARIOS_PROGRAMADO = 'outage-horarios-programado';

/**
 * Identificador de prueba del aviso del corte programado.
 */
export const TEST_ID_DISCLAIMER_PROGRAMADO = 'outage-disclaimer-programado';

/**
 * Identificador de prueba del avance del corte programado.
 */
export const TEST_ID_AVANCE_PROGRAMADO = 'outage-avance-programado';

/**
 * Identificador de prueba del enlace al detalle programado.
 */
export const TEST_ID_TOGGLE_DETALLE_PROGRAMADO = 'toggle-detalle-avance-programado';

/**
 * Identificador de prueba del bloque de reportar del corte programado.
 */
export const TEST_ID_REPORTAR_PROGRAMADO = 'outage-reportar-programado';

/**
 * Identificador de prueba del botón de reportar del corte programado.
 */
export const TEST_ID_BOTON_REPORTAR_PROGRAMADO = 'boton-reportar-corte-programado';

/**
 * Identificador de prueba del gráfico del corte programado.
 */
export const TEST_ID_CHART_PROGRAMADO = 'outage-chart-programado';

/**
 * Identificador de prueba del pie del dashboard programado.
 */
export const TEST_ID_FOOTER_PROGRAMADO = 'outage-footer-programado';

/**
 * Identificador de prueba del dashboard futuro.
 */
export const TEST_ID_DASHBOARD_FUTURO = 'outage-dashboard-futuro';

/**
 * Identificador de prueba del título del corte futuro.
 */
export const TEST_ID_TITULO_FUTURO = 'outage-titulo-futuro';

/**
 * Identificador de prueba de los horarios del corte futuro.
 */
export const TEST_ID_HORARIOS_FUTURO = 'outage-horarios-futuro';

/**
 * Identificador de prueba del aviso del corte futuro.
 */
export const TEST_ID_DISCLAIMER_FUTURO = 'outage-disclaimer-futuro';

/**
 * Identificador de prueba del avance del corte futuro.
 */
export const TEST_ID_AVANCE_FUTURO = 'outage-avance-futuro';

/**
 * Identificador de prueba de la hora de notificación del corte futuro.
 */
export const TEST_ID_HORA_NOTIFICACION_FUTURO = 'outage-hora-notificacion-futuro';

/**
 * Identificador de prueba del enlace al detalle futuro.
 */
export const TEST_ID_TOGGLE_DETALLE_FUTURO = 'toggle-detalle-avance-futuro';

/**
 * Identificador de prueba del bloque de reportar del corte futuro.
 */
export const TEST_ID_REPORTAR_FUTURO = 'outage-reportar-futuro';

/**
 * Identificador de prueba del botón de reportar del corte futuro.
 */
export const TEST_ID_BOTON_REPORTAR_FUTURO = 'boton-reportar-corte-futuro';

/**
 * Identificador de prueba del pie del dashboard futuro.
 */
export const TEST_ID_FOOTER_FUTURO = 'outage-footer-futuro';

/**
 * Identificador de prueba del TER suscrito del fallback KML.
 */
export const TEST_ID_KML_TER_SUSCRITO = 'outage-kml-ter-suscrito';

/**
 * Identificador de prueba del TER vacío del fallback KML.
 */
export const TEST_ID_KML_TER_VACIO = 'outage-kml-ter-empty';

/**
 * Identificador de prueba de la caja TER del fallback KML.
 */
export const TEST_ID_KML_TER_BOX = 'outage-kml-ter-box';

/**
 * Identificador de prueba de la suscripción inline del fallback KML.
 */
export const TEST_ID_KML_TER_SUSCRITO_INLINE = 'outage-kml-ter-suscrito-inline';

/**
 * Identificador de prueba del fallback KML.
 */
export const TEST_ID_KML_FALLBACK = 'outage-kml-fallback';

/**
 * Identificador de prueba del motivo del fallback KML.
 */
export const TEST_ID_KML_MOTIVO = 'outage-kml-motivo';

/**
 * Identificador de prueba del aviso del fallback KML.
 */
export const TEST_ID_KML_DISCLAIMER = 'outage-kml-disclaimer';

/**
 * Identificador de prueba del gráfico del fallback KML.
 */
export const TEST_ID_KML_CHART = 'outage-kml-chart';

/**
 * Identificador de prueba del pie del fallback KML.
 */
export const TEST_ID_KML_FOOTER = 'outage-kml-footer';

/**
 * Identificador de prueba del modal de detalle de avance.
 */
export const TEST_ID_DETALLE_MODAL = 'detalle-avance-modal';

/**
 * Identificador de prueba del botón volver del detalle.
 */
export const TEST_ID_DETALLE_VOLVER = 'detalle-avance-volver';

/**
 * Identificador del título del detalle de avance.
 */
export const ID_TITULO_DETALLE = 'detalle-avance-titulo';

/**
 * Identificador de prueba del overlay de suscripción TER.
 */
export const TEST_ID_MODAL_SUSCRIPCION_OVERLAY = 'modal-suscripcion-ter-overlay';

/**
 * Identificador de prueba del modal de suscripción TER.
 */
export const TEST_ID_MODAL_SUSCRIPCION = 'modal-suscripcion-ter';

/**
 * Identificador de prueba del captcha del modal de suscripción.
 */
export const TEST_ID_MODAL_SUSCRIPCION_CAPTCHA = 'modal-suscripcion-captcha-v3';

/**
 * Identificador de prueba del cierre del modal de suscripción.
 */
export const TEST_ID_MODAL_SUSCRIPCION_CERRAR = 'modal-suscripcion-cerrar';

/**
 * Identificador de prueba del envío del modal de suscripción.
 */
export const TEST_ID_MODAL_SUSCRIPCION_CONFIRMAR = 'modal-suscripcion-confirmar';

/**
 * Identificador del título del modal de suscripción TER.
 */
export const ID_TITULO_MODAL_SUSCRIPCION = 'modal-suscripcion-ter-titulo';

/**
 * Identificador de prueba del cierre del modal de polígono.
 */
export const TEST_ID_CERRAR_MODAL_POLIGONO = 'cerrar-modal-poligono';

/**
 * Prefijo del identificador de prueba de cada paso del detalle.
 */
export const PREFIJO_TEST_ID_PASO = 'detalle-paso-';

/**
 * Atributo que marca un nodo medible del timeline.
 */
export const ATRIBUTO_NODO_TIMELINE = 'data-timeline-node';

/**
 * Divisor para ubicar el centro vertical de un nodo.
 */
export const DIVISOR_CENTRO_NODO = 2;

/**
 * Calcula el ancho de la barra de progreso descontando el nodo final.
 * @param progressPct porcentaje de avance entre cero y cien
 * @returns ancho CSS de la barra
 */
export const anchoBarraProgreso = (progressPct: number): string => {
  if (progressPct <= PROGRESO_VACIO) {
    return `${PROGRESO_VACIO}${UNIDAD_PX}`;
  }
  return `calc((${PROGRESO_COMPLETO}% - ${ANCHO_NODO_TIMELINE_PX}${UNIDAD_PX}) * ${progressPct / PROGRESO_COMPLETO})`;
};
